// extracted by mini-css-extract-plugin
export default {"flagRecordButton":"flagRecordButton--tIevl","loading":"loading--_5XCy"};